import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "spr-increase",
  "use": "spr-increase-usage",
  "viewBox": "0 0 60 65",
  "content": "<symbol viewBox=\"0 0 60 65\" id=\"spr-increase\">\r\n<path d=\"M58.2,56.5H53V17.7h5.3c1.6,0,2.3-1.9,1.2-3L45.4,0.5c-0.7-0.7-1.8-0.7-2.5,0L28.9,14.7c-1.1,1.1-0.3,3,1.2,3h5.3v10.5H22.9\r\n\tc-1,0-1.8,0.8-1.8,1.8v8.8H8.8c-1,0-1.8,0.8-1.8,1.8v15.9H1.8c-1,0-1.8,0.8-1.8,1.8S0.8,60,1.8,60h56.5c1,0,1.8-0.8,1.8-1.8\r\n\tC60,57.3,59.2,56.5,58.2,56.5z M21.1,56.5H10.5V42.3h10.5V56.5z M35.4,56.5H24.6V31.8h10.8V56.5z M49.5,15.9v40.5H38.9V15.9\r\n\tc0-1-0.8-1.8-1.8-1.8h-2.8l9.8-9.9l9.8,9.9h-2.8C50.2,14.2,49.5,15,49.5,15.9z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ../img/sprite/increase.svg
// module id = 332
// module chunks = 0